import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/FetchAvailableAppsSummary";

export function* fetchAvailableAppsSummary(action: Actions.FetchAvailableAppsSummaryAction) {
    const { payload } = action;
    const { credentials, organizationId, template } = payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const summary = yield api.getAvailableApps(organizationId, template);
        yield put(Actions.fetchAvailableAppsSummaryEnd(undefined, organizationId, summary));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.fetchAvailableAppsSummaryEnd(e, organizationId));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchAvailableAppsSummary() {
    yield takeEvery(Actions.FETCH_AVAILABLE_APPS_SUMMARY, fetchAvailableAppsSummary);
}
